var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF1FAA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_35184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6631 7.12734C12.6631 6.6875 13.0073 6.33093 13.432 6.33093C16.7231 6.33093 19.3911 9.09429 19.3911 12.5031V32.8726C19.3911 33.3125 19.0468 33.6691 18.6222 33.6691C15.3311 33.6691 12.6631 30.9058 12.6631 27.4969V7.12734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1675 15.0387C20.1675 14.5962 20.5138 14.2375 20.9411 14.2375C25.5873 14.2375 29.3538 18.1387 29.3538 22.951V24.9555C29.3538 29.7678 25.5873 33.669 20.9411 33.669C20.5138 33.669 20.1675 33.3103 20.1675 32.8678V15.0387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3041 25.1363L20.1543 28.5714L20.1654 19.4286L25.315 22.9493C26.0579 23.4574 26.0519 24.6376 25.3041 25.1363Z",
    fill: "#FF1FAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_35184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6906,
    height: 27.3381,
    fill: "white",
    transform: "translate(12.6631 6.33093)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo_sm.4561302cafd737f93e8fa56a5bce1dc7.svg";
export { ForwardRef as ReactComponent };